import styled from 'styled-components';

export default styled.div`
  position: relative;
  text-align: center;
  margin-bottom: 2rem;
  font-weight: 500;
  width: 300px;
  max-width: 100%;
  margin: 0 auto;
`;
